module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Account-Creation_05-5bd6276ff1de6904a2d7de570d7ad5b2.jpg";